module.exports = __webpack_public_path__ + "static/media/webdesign-services-img54.b7e441f8.jpg";